"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutApi = exports.refreshTokenApi = exports.optRequestApi = exports.optVerificationApi = exports.cookieAuthApi = exports.loginApi = exports.signupApi = void 0;
const apiPath_1 = require("../apiPath");
const signupApi = async (axiosInstance, { mobileNumber }) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.auth.signUp.frontend, {
            mobileNumber,
        });
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.signupApi = signupApi;
const loginApi = async (axiosInstance, form) => {
    // Todo: login should  return a code  that could be look up for the opt code 
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.auth.login.frontend, form);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.loginApi = loginApi;
const cookieAuthApi = async (axiosInstance) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.auth.authByCookie.frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.cookieAuthApi = cookieAuthApi;
const optVerificationApi = async (axiosInstance, form) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.auth.optConfirmation.frontend, form);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.optVerificationApi = optVerificationApi;
const optRequestApi = async (axiosInstance) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.auth.optRequest.frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.optRequestApi = optRequestApi;
const refreshTokenApi = async (axiosInstance, token) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.auth.refreshToken.frontend, {
            refreshToken: token
        });
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.refreshTokenApi = refreshTokenApi;
const logoutApi = async (axiosInstance) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.auth.refreshToken.frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.logoutApi = logoutApi;
//# sourceMappingURL=auth.js.map